
import Swal from 'sweetalert2'
import Colors from '../../constants/Colors'

export const alertBeforeHandle = (text, onFunc) => {
  Swal.fire({
    title: text,
    icon: 'question',
    showCancelButton: true,
    confirmButtonColor: Colors.SOFT_BLUE,
    cancelButtonColor: Colors.LIGHT_RED,
    confirmButtonText: 'ยืนยัน',
    cancelButtonText: 'ยกเลิก',
  }).then(async (result) => {
    if (result.isConfirmed) {
      await onFunc()
    }
  })
}
